/* Like the "Not interested" toast (features/profile/profile.module.css .toast): at the bottom of the map. */
.note { position: fixed; z-index: 20; left: calc(var(--panel-w) + 16px); right: 16px; bottom: 24px; margin: 0 auto; width: fit-content; max-width: 480px;
  background: var(--surface); border-radius: var(--radius); box-shadow: var(--shadow-pop); padding: 14px 18px; font-weight: 600;
  animation: note-in .25s var(--ease); }
.leaving { animation: note-out .2s ease-in forwards; }
@keyframes note-in { from { opacity: 0; transform: translateY(16px); } }
@keyframes note-out { to { opacity: 0; transform: translateY(16px); } }
@media (max-width: 760px) { .note { left: 10px; right: 10px; bottom: calc(12px + env(safe-area-inset-bottom)); } }
